module.exports = __webpack_public_path__ + "static/media/subscribed.98e379f2.svg";